module.exports = {
  src: __webpack_public_path__ + "static/media/families_00027.48cff718.jpg",
  width: 2400,
  height: 1800,
  bytes: 393193,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/families_00027.48cff718.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/galleries/families/families_00027.jpg
// module id = 413
// module chunks = 0